/* eslint-disable linebreak-style */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from 'src/app/@amiga-pyme/services/crud.service';

const baseRoute = '/users/active';

@Injectable({
  providedIn: 'root'
})
export class UserActiveService extends CrudService {
  constructor(http: HttpClient) {
    super(http, baseRoute);
  }
}
